export const computeTrend = (data: any[], yKeyName: string) => {
  if (data.length === 0) return [];
  const n = data.length;
  const sumX = data.reduce((acc, point, index) => acc + index, 0);
  const sumY = data.reduce((acc, point) => acc + point[yKeyName], 0);
  const sumXY = data.reduce((acc, point, index) => acc + index * point[yKeyName], 0);
  const sumX2 = data.reduce((acc, point, index) => acc + index * index, 0);

  const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  return data.map((point, index) => ({
    month: point.month,
    [yKeyName]: intercept + slope * index,
  }));
}
